<template>
    <div class="mb-5 mt-5 p-5 bg-white rounded-xl shadow">
        <h3 class="text-xl font-bold">Aplicar descuento</h3>
        <form @submit.prevent="submit">
            <div class="mb-2">
                <text-input 
                    v-model="form.percentage" 
                    :label="'Porcentaje'" 
                    type="number"
                    :max="100"
                    :min="0"
                />
                <textarea-input 
                    v-model="form.description" 
                    label="Descripción" 
                    placeholder="Indica el porqué de este codigo">
                </textarea-input>
            </div>
            <loading-button :loading="form.processing" class="btn-blue" type="submit">Aplicar descuento</loading-button>
        </form>
    </div>
</template>

<script>
import LoadingButton from './LoadingButton.vue'
import SelectInput from './SelectInput.vue'
import TextareaInput from './TextareaInput.vue'
import TextInput from './TextInput.vue'
export default {
  components: { TextInput, TextareaInput, LoadingButton, SelectInput },
    // En este componente, se podrá cambiar a los diferentes estatus, pero por ahora vamos a pasar de presupuesto a de contado
    props: {
        order: Object
    },  
    data()
    {
        return {
            form : this.$inertia.form({
                percentage: 0,
                description: '',
                order_id: this.order.id
            })
        }
    },
    methods: {
        submit() {
            this.form.post('/orders/discounts');
        }
    }
}
</script>